const paths = {
  listEmailNotifications: '/notifications/email',
  listConsoleNotifications: '/notifications/console',
  listWebServiceNotifications: '/notifications/webService',
  listSystemNotifications: '/notifications/system',
  listNotifications: '/notifications/:screenType',
  listTrackerNotifications: '/notifications/tracker'
};

export default paths;
